import { createFileRoute } from "@tanstack/react-router";
import Avisos from "@/pages/app/Avisos";

export const Route = createFileRoute("/app/avisos")({
  head: () => ({ meta: [{ title: "Avisos | Braussie - Nutri" }] }),
  component: Avisos,
});
